// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3D2pe","containerCards":"styles_containerCards__2ibSI"};